import React from "react";
import { sanitizeLatexInput } from "../../../../../../utils/app";

interface QuestionContentTitleProps {
  content: string;
}

function QuestionContentTitle({ content }: QuestionContentTitleProps) {
return (
    <div
      className="font-size-16 line-height-24 font-weight-6"
      dangerouslySetInnerHTML={{
        __html: `${sanitizeLatexInput(content)}`,
      }}
    ></div>
  );
}

export default QuestionContentTitle;
